export const canEdit = ({ member }) => !!member;

export const canView = (accessRestricted, { permissionReader }) => !accessRestricted || !!permissionReader;

export const canUpload = ({ permissionDocumentUpload }) => !!permissionDocumentUpload;

export const ownerCheck = ({owner}, {permissionOwner}, userUuid) => !!permissionOwner || owner === userUuid;